import { useState, useCallback } from 'react';
import SubmittingPreScreeningComponent, {
  SubmittingPreScreeningProps,
  PreScreeningQuestionType,
} from './SubmittingPreScreening.component';

export default function SubmittingPreScreening({
  questions,
  ...props
}: Pick<SubmittingPreScreeningProps, 'questions' | 'onSubmitAnswers'>): JSX.Element {
  const [currentQuesiton, setCurrentQuestion] = useState(0);
  const [allQuestions, setAllQuestions] = useState<PreScreeningQuestionType[]>(questions);

  const goToNextQuestion = (): void => {
    setCurrentQuestion((prev) => prev + 1);
  };
  const goToPrevQuestion = (): void => {
    setCurrentQuestion((prev) => prev - 1);
  };

  const onSaveAnswer = useCallback(
    (event: any): void => {
      setAllQuestions((prev) => {
        return prev.map((question, index) => {
          if (index !== currentQuesiton) {
            return question;
          }

          return {
            ...question,
            ...event,
          };
        });
      });
    },
    [currentQuesiton]
  );

  const onDeleteAnswer = (): void => {
    setAllQuestions((prev) => {
      return prev.map((question, index) => {
        if (index !== currentQuesiton) {
          return question;
        }

        return {
          id: question.id,
          label: question.label,
        };
      });
    });
  };

  const isLastQuestion = currentQuesiton === questions.length - 1;
  const questionNotAnswered = !allQuestions[currentQuesiton].url;

  return (
    <SubmittingPreScreeningComponent
      currentQuesiton={currentQuesiton}
      isLastAnswer={isLastQuestion}
      hasNotAnswered={questionNotAnswered}
      goToNextQuestion={goToNextQuestion}
      goToPrevQuestion={goToPrevQuestion}
      onSaveAnswer={onSaveAnswer}
      onDeleteAnswer={onDeleteAnswer}
      questionNotAnswered={questionNotAnswered}
      isLastQuestion={isLastQuestion}
      questions={allQuestions}
      {...props}
    />
  );
}
